<terra-dialog-header class="investing-entity-share-dialog-header">
  <h1 class="share-header">
    <button mat-icon-button (click)="back()" class="action-btn" *ngIf="isSharing || isEditing" @inOutPaneAnimation>
      <mat-icon>arrow_back</mat-icon>
    </button>
    {{ isEditing ? 'Edit Access' : 'Share' }}
  </h1>
</terra-dialog-header>

<div class="share-with-modal">

  <mat-dialog-content>
    <ng-container *ngIf="({
      investingEntities: investingEntities$ | async,
      sharedEntities: sharedEntities$ | async,
      userDetails: userDetails$ | async
    }) as view">
      <ng-container *ngIf="view.investingEntities; else loading;">
        <form id="shareForm" [formGroup]="shareForm">

          <div class="share-with-email-block">
            <div class="share-with-field">
              <mat-label class="share-label">Share with</mat-label>
              <mat-form-field appearance="outline" class="email-field">
                <input matInput type="email" email="true" formControlName="email" [readOnly]="isEditing"
                       placeholder="Type email address">
                <span matSuffix class="viewer">Viewer <mat-icon pTooltip="Viewers can view portfolio and download files"
                                                                tooltipPosition="top">help_outline</mat-icon></span>
                <mat-error *ngIf="shareForm.get('email').hasError('email')">
                  Please enter a valid email address
                </mat-error>
                <mat-error *ngIf="shareForm.get('email').hasError('emailExists')">
                  <div>The email you entered is already included in the list below.</div>
                  <div>To modify the sharing settings, please click on "Edit"</div>
                </mat-error>

              </mat-form-field>
            </div>
            <div class="share-btn-block">
              <ng-container *ngIf="!isEditing">
                <button *ngIf="view.investingEntities?.length > 1 && !isSharing" mat-flat-button color="primary"
                        (click)="continue()" [disabled]="!shareForm.get('email').value || shareForm.get('email').invalid"
                        class="share-btn">
                  Continue
                </button>
                <button *ngIf="view.investingEntities?.length == 1 || isSharing" mat-flat-button color="primary"
                        (click)="share()" [disabled]="!canShare" class="share-btn">
                  Share
                </button>
              </ng-container>
              <button *ngIf="isEditing" mat-flat-button color="primary" (click)="update()"
                      [disabled]="!shareForm.get('email').value || shareForm.invalid" class="share-btn">
                Update
              </button>
            </div>
          </div>

          <mat-tab-group [dynamicHeight]="true" [selectedIndex]="selectedTab" (animationDone)="tabsAnimationDone()" mat-stretch-tabs="false" mat-align-tabs="start">
            <mat-tab>
              <div class="share-list-block">
                <div class="share-list-header"> People with access</div>
                <mat-accordion class="share-list" multi>

                  <mat-expansion-panel hideToggle class="share-list-item" disabled>
                    <mat-expansion-panel-header>
                      <mat-panel-title class="share-list-title">
                        <div class="share-list-user owner">
                          <div class="share-list-user-info">
                            <p-avatar [label]="avatarLetters(view.userDetails.firstName, view.userDetails.lastName)"
                                      styleClass="mr-2" size="large" shape="circle"></p-avatar>
                            <div class="share-list-user-info-block">
                              <div class="share-list-user-name">
                                {{ view.userDetails.firstName }} {{ view.userDetails.lastName }}
                              </div>
                              <div class="share-list-user-email">
                                {{ view.userDetails.email }}
                              </div>
                              <div class="viewer">Owner</div>
                            </div>
                          </div>
                          <div class="viewer">Owner</div>
                        </div>
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                  </mat-expansion-panel>
                  <mat-expansion-panel *ngFor="let sharedEntity of view.sharedEntities" hideToggle
                                       class="share-list-item">
                    <mat-expansion-panel-header>
                      <mat-panel-title class="share-list-title">
                        <div class="share-list-user">
                          <div class="share-list-user-info">
                            <p-avatar [label]="avatarLetters(sharedEntity.user.name || sharedEntity.user.email)"
                                      styleClass="mr-2" size="large" shape="circle"></p-avatar>
                            <div class="share-list-user-info-block">
                              <div class="share-list-user-name" *ngIf="sharedEntity.user.name">
                                {{ sharedEntity.user.name }}
                              </div>
                              <div class="share-list-user-email">
                                {{ sharedEntity.user.email }}
                              </div>
                              <div class="viewer">Viewer
                                <mat-icon pTooltip="Viewers can view portfolio and download files"
                                          tooltipPosition="top">help_outline
                                </mat-icon>
                              </div>
                            </div>
                          </div>
                          <div class="viewer">Viewer
                            <mat-icon pTooltip="Viewers can view portfolio and download files"
                                      tooltipPosition="top">help_outline
                            </mat-icon>
                          </div>
                        </div>
                        <div class="share-list-menu">
                          <button *ngIf="!isMobile" mat-icon-button disableRipple [matMenuTriggerFor]="menu"
                                  [matMenuTriggerData]="{entity: sharedEntity}" (click)="$event.stopPropagation();">
                            <mat-icon>more_vert</mat-icon>
                          </button>
                          <button *ngIf="isMobile" mat-icon-button disableRipple (click)="$event.stopPropagation();openMenu(sharedEntity)">
                            <mat-icon>more_vert</mat-icon>
                          </button>
                        </div>
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <mat-chip-set class="investingEntities">
                      <terra-investing-entity-chip *ngFor="let ent of sharedEntity.investingEntities"
                                                   [investingEntity]="ent" [active]="false">
                      </terra-investing-entity-chip>
                    </mat-chip-set>

                  </mat-expansion-panel>
                </mat-accordion>
              </div>

            </mat-tab>
            <mat-tab>
              <!-- edit block  -->
              <div class="share-with-selector">
                <div class="share-with-header">Select entities to share</div>
                <mat-form-field class="chip-list" appearance="outline">
                  <mat-icon matPrefix class="mr-1">search</mat-icon>
                  <mat-chip-grid #chipList class="investingEntities mt-0">
                    <terra-investing-entity-chip *ngFor="let item of entities" [investingEntity]="item"
                                                 (remove)="remove($event)">
                    </terra-investing-entity-chip>
                    <input placeholder="Search for entity" #searchInput [formControl]="search" [matAutocomplete]="auto"
                      #trigger="matAutocompleteTrigger" [matChipInputFor]="chipList">
                  </mat-chip-grid>
                  <mat-autocomplete #auto="matAutocomplete" class="investing-entities-autocomplete"
                                    (optionSelected)="selected($event)">
                    <mat-option class="entity-items-option" *ngFor="let item of filteredEntities | async"
                                [value]="item">
                      <div (click)="optionClicked($event, item);">
                        <mat-checkbox disableRipple [checked]="entities.includes(item)" labelPosition="before"
                                      color="primary" (change)="toggleSelection(item)" (click)="$event.stopPropagation()">

                          <div class="investing-entities-items">
                            <mat-icon [svgIcon]="InvestingEntityType.getIcon(item.investingEntityType)" class="avatar-icon"></mat-icon>

                            <div class="investing-entities-info">
                              <div class="investing-entities-name">
                                {{ item.name }}
                              </div>
                              <div class="investing-entities-list">
                                {{ item.investedHoldingsNames?.join(', ') }}
                              </div>
                            </div>

                          </div>
                        </mat-checkbox>
                      </div>
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </div>

            </mat-tab>
          </mat-tab-group>
        </form>

        <mat-menu #menu="matMenu" class="edit-share-menu" xPosition="before">
          <ng-template matMenuContent let-entity="entity">
            <button mat-menu-item *ngIf="view.investingEntities?.length > 1" class="edit-share-menu-item"
                    (click)="edit(entity)">
              <mat-icon color="primary" fontSet="material-icons-outlined">edit</mat-icon>
              <span>Edit access</span>
            </button>
            <button mat-menu-item class="edit-share-menu-item" *ngIf="!entity.user.name"
                    (click)="resend(entity.user.email)">
              <mat-icon color="primary">mail_outline</mat-icon>
              <span>Resend invite</span>
            </button>
            <button mat-menu-item class="edit-share-menu-item" (click)="delete(entity.user.email, entity.user.name)">
              <mat-icon color="primary">delete_outline</mat-icon>
              <span>Remove access</span>
            </button>
          </ng-template>
        </mat-menu>

      </ng-container>
    </ng-container>

  </mat-dialog-content>
</div>

<ng-template #loading>
  <terra-loader class="place-middle"></terra-loader>
</ng-template>
